/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".template[_ngcontent-%COMP%]{position:static}.template[_ngcontent-%COMP%]   .loader-hidden[_ngcontent-%COMP%]{visibility:hidden}.template[_ngcontent-%COMP%]   .loader-overlay[_ngcontent-%COMP%]{position:absolute;top:0;left:0;opacity:1;z-index:999;width:100%;height:100%;background:rgba(255,255,255,.5);color:#000;text-align:center;line-height:200px}.template   [_nghost-%COMP%]     path{stroke:#2196f3!important}.template[_ngcontent-%COMP%]   #loader[_ngcontent-%COMP%]{position:absolute;top:45%;left:45%;font-size:35px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/css/spinner.component.less.shim.ngstyle.js.pre-build-optimizer.js